import React from "react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { MfaManager } from "./MfaManager";
import { ShieldAlert } from "lucide-react";

// Persistent, non-dismissable gate. Firm members + platform owner MUST enroll in MFA.
// It stays on screen across reloads until MFA is enabled.
export function MfaRequiredGate() {
  const { user } = useAuth();
  if (!user || typeof user !== "object") return null;
  if (!user.mfa_setup_required) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center px-5 bg-[#050505]/95 backdrop-blur-md" data-testid="mfa-required-gate">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#0d0f0e] p-6 sm:p-8 text-white">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-11 h-11 rounded-xl bg-amber-400/15 border border-amber-400/30 flex items-center justify-center shrink-0"><ShieldAlert size={20} className="text-amber-300" /></div>
          <div>
            <h2 className="font-editorial text-2xl tracking-tight leading-none mb-1">Secure your account</h2>
            <p className="text-[11.5px] uppercase tracking-[0.14em] text-amber-300/80 font-medium">Required for all firm accounts</p>
          </div>
        </div>
        <p className="text-[13.5px] text-white/60 leading-relaxed mb-6">
          Set up two-factor authentication with an authenticator app to continue. It only takes a minute and can't be skipped.
        </p>
        <div className="border-t border-white/10 pt-5">
          <MfaManager
            client={api}
            base="/firm/mfa"
            enabled={false}
            mandatory
            setupOnly
            theme="dark"
            onChange={(on) => { if (on) setTimeout(() => window.location.reload(), 1200); }}
          />
        </div>
      </div>
    </div>
  );
}
